/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/* MRD_GLOBAL_STICKY_HEADER_2026_10_22
 * Site-wide sticky header with measured width and no layout jump.
 * Replaces the old header-only scrollToFixed behavior; does not
 * affect sticky product boxes, FAQ categories, or navigation drawers.
 */
(function () {
  'use strict';

  var header;
  var spacer;
  var container;
  var headerStart = 0;
  var isFixed = false;
  var scheduled = false;

  function scrollY() {
    return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function setFixed(shouldFix) {
    if (isFixed === shouldFix) return;
    isFixed = shouldFix;

    if (shouldFix) {
      spacer.style.height = header.offsetHeight + 'px';
      header.classList.add('mrd-global-sticky-active');
    } else {
      header.classList.remove('mrd-global-sticky-active');
      header.style.removeProperty('left');
      header.style.removeProperty('width');
      spacer.style.height = '0px';
    }
  }

  function refresh() {
    scheduled = false;
    if (!header || !document.documentElement.contains(header)) return;

    setFixed(scrollY() > headerStart);

    if (isFixed) {
      var rect = (container || document.documentElement).getBoundingClientRect();
      header.style.left = rect.left + 'px';
      header.style.width = rect.width + 'px';
      spacer.style.height = header.offsetHeight + 'px';
    }
  }

  function scheduleRefresh() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(refresh);
  }

  function remeasure() {
    if (!header) return;
    setFixed(false);
    headerStart = scrollY() + header.getBoundingClientRect().top;
    scheduleRefresh();
  }

  function init() {
    var el = document.querySelector('header.js-header');
    if (!el || el.hasAttribute('data-mrd-global-sticky')) return;
    header = el;
    // Venue's optional scroll-hide class can translate the header off-screen.
    // The global sticky implementation replaces that behavior site-wide.
    header.classList.remove('js-header-scroll');
    header.style.removeProperty('transform');
    header.style.removeProperty('-webkit-transform');
    header.style.removeProperty('-moz-transform');
    document.body.classList.remove('header-up');
    container = document.querySelector('.page-container');
    header.setAttribute('data-mrd-global-sticky', '1');

    // The legacy Venue script initializes earlier. Detach only the
    // header's scrollToFixed handler so two systems cannot compete.
    if (window.jQuery) {
      window.jQuery(header).trigger('detach.ScrollToFixed');
    }

    spacer = document.createElement('div');
    spacer.id = 'mrd-global-sticky-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.parentNode.insertBefore(spacer, header);

    headerStart = scrollY() + header.getBoundingClientRect().top;
    window.addEventListener('scroll', scheduleRefresh, { passive: true });
    window.addEventListener('resize', remeasure, { passive: true });
    window.addEventListener('orientationchange', remeasure, { passive: true });
    window.addEventListener('load', remeasure);
    // Safari back/forward cache restores scroll position without re-running DOM ready.
    window.addEventListener('pageshow', remeasure);
    scheduleRefresh();
  }

  // Venue registers its DOM-ready handlers before custom.js, allowing
  // the native sticky replacement to run after the legacy initializer.
  if (window.jQuery) {
    window.jQuery(function () { window.setTimeout(init, 0); });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
 

/* MRD_MOBILE_SUBMENU_TOGGLE_2026_10_22
 * Capture clicks on links that expand a mobile-drawer submenu.
 * Venue also registers an ordinary jQuery click handler; intercept here
 * so the submenu isn't toggled twice and the anchor cannot jump pages.
 * Delegation survives the drawer being moved into the popup container.
 */
(function () {
  'use strict';

  function toggleSubmenu(event) {
    var clicked = event.target;
    if (!clicked || !clicked.closest) return;

    var trigger = clicked.closest('.js-menu-draw .js-toggle-trigger');
    if (!trigger) return;

    var href = trigger.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;

    var menu = trigger.closest('.js-menu-draw');
    var target = document.getElementById(href.slice(1));
    if (!menu || !target || !menu.contains(target) || !target.classList.contains('js-toggle-target')) return;

    event.preventDefault();
    // Block Venue's bubble-phase toggle to prevent duplicate expand/collapse.
    event.stopPropagation();

    var isOpen = trigger.classList.toggle('js-active');
    target.classList.toggle('js-active', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    var item = trigger.parentElement;
    if (item) item.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  document.addEventListener('click', toggleSubmenu, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== ' ' && event.key !== 'Spacebar') return;
    var trigger = event.target;
    if (!trigger || !trigger.matches || !trigger.matches('.js-menu-draw .js-toggle-trigger')) return;
    event.preventDefault();
    trigger.click();
  }, true);
})();


/* MRD_SAFE_ADD_TO_CART_FEEDBACK_20261104
 * Purely visual feedback. Never disable the submit button, cancel form
 * submissions, intercept the app's requests, or call preventDefault().
 * The SC Product Options app and Shopify still handle every submission.
 */
(function () {
  'use strict';

  var active = null;

  function isVisible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }

  function validationErrors(form) {
    return Array.prototype.filter.call(
      form.querySelectorAll('.bold_option_error, .bold_error_message'),
      isVisible
    );
  }

  function finish() {
    if (!active) return;
    var current = active;
    active = null;
    window.clearTimeout(current.startTimer);
    window.clearTimeout(current.slowTimer);
    window.clearTimeout(current.helpTimer);
    if (current.observer) current.observer.disconnect();
    if (current.help && current.help.parentNode) {
      current.help.parentNode.removeChild(current.help);
    }
    if (current.button && current.button.classList) {
      current.button.classList.remove('mrd-cart-pending', 'mrd-cart-pending-long');
      current.button.removeAttribute('aria-busy');
    }
  }

  function showCartLink(current) {
    if (active !== current || current.help || !current.button.isConnected) return;
    var help = document.createElement('p');
    help.className = 'mrd-cart-delay-help';
    help.setAttribute('role', 'status');
    help.appendChild(document.createTextNode(
      'Taking longer than expected? Check your cart before adding again. '
    ));
    var link = document.createElement('a');
    link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/') + 'cart';
    link.textContent = 'CHECK CART';
    help.appendChild(link);
    var container = current.button.closest('.product-single__add') ||
      current.button.parentElement;
    container.insertAdjacentElement('afterend', help);
    current.help = help;
  }

  function showFeedback(current) {
    if (active !== current || current.invalid || !current.button.isConnected) return;
    // SC can reject missing required options synchronously, before we paint.
    var errorsNow = validationErrors(current.form);
    if (errorsNow.some(function (error) {
      return current.previousErrors.indexOf(error) === -1;
    })) {
      finish();
      return;
    }

    current.button.classList.add('mrd-cart-pending');
    current.button.setAttribute('aria-busy', 'true');

    // Observe only new, visible custom-option validation errors.
    if (window.MutationObserver) {
      current.observer = new MutationObserver(function () {
        if (active !== current) return;
        var errors = validationErrors(current.form);
        if (errors.some(function (error) {
          return current.previousErrors.indexOf(error) === -1;
        })) finish();
      });
      current.observer.observe(current.form, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }

    current.slowTimer = window.setTimeout(function () {
      if (active === current) current.button.classList.add('mrd-cart-pending-long');
    }, 9000);

    // A safe navigation alternative, not a timer-based re-submission.
    current.helpTimer = window.setTimeout(function () {
      showCartLink(current);
    }, 15000);
  }

  // Listen only to real customer clicks, never scripted clicks from
  // SC Product Options or other Shopify apps.
  document.addEventListener('click', function (event) {
    if (!event.isTrusted) return;
    var target = event.target;
    var button = target && target.closest && target.closest('button.js-product-add');
    if (!button || button.disabled) return;
    var form = button.closest('form.js-product-form');
    if (!form || active) return;

    var current = {
      form: form,
      button: button,
      previousErrors: validationErrors(form),
      invalid: false,
      startTimer: 0,
      slowTimer: 0,
      helpTimer: 0,
      help: null,
      observer: null
    };
    active = current;

    // Defer the cosmetic change until the native click/submit and the options
    // app have run. The click's default action is completely untouched.
    current.startTimer = window.setTimeout(function () {
      showFeedback(current);
    }, 0);
  }, true);

  // Native HTML validation can prevent a submit; it must restore the UI.
  document.addEventListener('invalid', function (event) {
    if (active && active.form.contains(event.target)) {
      active.invalid = true;
      finish();
    }
  }, true);

  // Shopify's optional Ajax-cart error event (if enabled in the future).
  if (window.jQuery) {
    window.jQuery(document.body).on('errorAddItem.ajaxCart', finish);
  }

  // Restored pages (iOS Safari bfcache) should never retain a loading state.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) finish();
  });
})();


/* MRD_DESKTOP_CART_VISUAL_FALLBACK_20261104
 * Desktop only: shows the same visual button feedback as mobile, but anchors
 * the state to the product section instead of a button the options app might
 * replace. Does not alter /cart/add, form events, paid options, or redirects.
 */
(function () {
  'use strict';

  var pending = null;
  var queued = null;

  function desktop() {
    return window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
  }
  function visible(el) {
    return !!(el && el.getClientRects && el.getClientRects().length);
  }
  function errors(section) {
    return Array.prototype.filter.call(
      section.querySelectorAll(
        '.custom-gallery-thumbs .bold_option_error, ' +
        '.custom-gallery-thumbs .bold_error_message'
      ), visible
    );
  }
  function clear() {
    if (queued) {
      window.clearTimeout(queued.timer);
      queued = null;
    }
    if (!pending) return;
    var old = pending;
    pending = null;
    window.clearTimeout(old.slowTimer);
    window.clearTimeout(old.helpTimer);
    if (old.observer) old.observer.disconnect();
    old.section.classList.remove(
      'mrd-desktop-cart-pending', 'mrd-desktop-cart-pending-long'
    );
    if (old.help && old.help.parentNode) old.help.parentNode.removeChild(old.help);
  }
  function activate(request) {
    if (queued !== request) return;
    queued = null;
    var section = request.section;
    if (!desktop() || !section.isConnected) return;
    var button = section.querySelector(
      '.custom-gallery-thumbs button.js-product-add'
    );
    if (!visible(button)) return;

    // Don't show processing when SC flags newly invalid required options.
    if (errors(section).some(function (el) {
      return request.existingErrors.indexOf(el) === -1;
    })) return;
    pending = request;
    section.classList.add('mrd-desktop-cart-pending');

    if (window.MutationObserver) {
      request.observer = new MutationObserver(function () {
        if (pending !== request) return;
        if (errors(section).some(function (el) {
          return request.existingErrors.indexOf(el) === -1;
        })) clear();
      });
      request.observer.observe(section, {
        childList: true, subtree: true, attributes: true,
        attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
      });
    }
    request.slowTimer = window.setTimeout(function () {
      if (pending === request) section.classList.add('mrd-desktop-cart-pending-long');
    }, 9000);

    request.helpTimer = window.setTimeout(function () {
      if (pending !== request || section.querySelector('.mrd-cart-delay-help')) return;
      var addArea = section.querySelector(
        '.custom-gallery-thumbs .product-single__add'
      );
      if (!addArea || !addArea.parentNode) return;
      var help = document.createElement('p');
      help.className = 'mrd-cart-delay-help';
      help.setAttribute('role', 'status');
      help.appendChild(document.createTextNode(
        'Taking longer than expected? Check your cart before adding again. '
      ));
      var link = document.createElement('a');
      link.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root : '/') + 'cart';
      link.textContent = 'CHECK CART';
      help.appendChild(link);
      addArea.insertAdjacentElement('afterend', help);
      request.help = help;
    }, 15000);
  }
  function begin(button) {
    if (!desktop() || pending || queued || !button || button.disabled) return;
    var form = button.closest('form.js-product-form');
    var section = button.closest('.section--product-single');
    if (!form || !section || !button.closest('.custom-gallery-thumbs')) return;
    if (form.checkValidity && !form.checkValidity()) return;
    var request = {
      section: section, existingErrors: errors(section),
      timer: 0, slowTimer: 0, helpTimer: 0,
      observer: null, help: null
    };
    queued = request;
    // After the click and its native default action, avoiding any disruption
    // of SC's own form/option submission.
    request.timer = window.setTimeout(function () { activate(request); }, 0);
  }
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest &&
      event.target.closest('button.js-product-add');
    if (button) begin(button);
  }, true);
  // Also cover native keyboard submissions on the desktop-only product form.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.js-product-form')) return;
    var button = event.submitter && event.submitter.matches &&
      event.submitter.matches('button.js-product-add')
        ? event.submitter : form.querySelector('button.js-product-add');
    if (button) begin(button);
  }, true);
  document.addEventListener('invalid', function (event) {
    if (queued && queued.section.contains(event.target)) clear();
    else if (pending && pending.section.contains(event.target)) clear();
  }, true);
  if (window.jQuery) {
    window.jQuery(document.body).on('errorAddItem.ajaxCart', clear);
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) clear();
  });
})();
